export default __webpack_public_path__ + "static/media/kids.a63887a2.svg";